import React, { useState } from 'react';
import { Play } from 'lucide-react';

export const getYoutubeId = (url) => {
  if (!url) return null;
  if (url.includes('youtube.com/watch')) return new URLSearchParams(url.split('?')[1]).get('v');
  for (const marker of ['youtu.be/', 'youtube.com/embed/', 'youtube.com/shorts/']) {
    if (url.includes(marker)) return url.split(marker)[1]?.split(/[?&]/)[0] || null;
  }
  return null;
};

export const getYoutubeEmbedUrl = (url) => {
  const id = getYoutubeId(url);
  return id ? `https://www.youtube.com/embed/${id}` : null;
};

// Thumbnail only; the heavy YouTube player loads on click.
export const YoutubeLite = ({ url, title, testId }) => {
  const [playing, setPlaying] = useState(false);
  const id = getYoutubeId(url);
  if (!id) return null;

  if (playing) {
    return (
      <div className="aspect-video rounded-lg overflow-hidden bg-black mb-3">
        <iframe
          src={`https://www.youtube.com/embed/${id}?autoplay=1&rel=0`}
          title={title}
          className="w-full h-full"
          frameBorder="0"
          allow="autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => setPlaying(true)}
      className="group relative block w-full aspect-video rounded-lg overflow-hidden bg-black mb-3"
      data-testid={testId}
      aria-label={`Assistir vídeo: ${title}`}
    >
      <img
        src={`https://i.ytimg.com/vi/${id}/mqdefault.jpg`}
        alt={title}
        loading="lazy"
        decoding="async"
        className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-200"
      />
      <span className="absolute inset-0 flex items-center justify-center">
        <span className="w-14 h-14 rounded-full bg-neon-lime/90 flex items-center justify-center shadow-[0_0_24px_rgba(204,255,0,0.4)] group-hover:scale-110 transition-transform duration-200">
          <Play className="w-6 h-6 text-black fill-black ml-0.5" />
        </span>
      </span>
    </button>
  );
};
